/* src/app/components/payroll/authorizations/auth-allocation-list/auth-allocation-list.component.css */
::ng-deep ppl-dialog div.popup-dialog .ant-form-item {
  margin-bottom: 30px;
}
:host ::ng-deep ppl-list-table td > p.error-message {
  font-size: 0;
}
:host ::ng-deep ppl-list-table td > p.error-message::after {
  content: "No service details added for this provider allocation.";
  font-size: 14px;
}
:host ::ng-deep .line-item-table a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 12px;
  border: 1px solid #5f7380;
  border-radius: 8px;
  background: #fff;
  color: #17384b;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}
:host ::ng-deep .line-item-table a::before {
  content: "\f040";
  font-family: "FontAwesome";
}
.action-container {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
/*# sourceMappingURL=auth-allocation-list.component-ISR3WWJZ.css.map */
